<template>
  <li
    :class="classes"
    :style="styles"
  >
    <a :href="href">
      <slot name="link" />
    </a>
  </li>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'link-item',
  props: {
    color: {
      type: String,
      default: '#43515A',
    },
    href: {
      type: String,
    },
    align: {
      type: String,
      default: 'left'
    }
  },
  setup(props) {
    const classes = computed(() => [
      'link-item',
      `link-item--${props.align}`
    ])
    const styles = computed(() => ({
      color: props.color
    }))
    return {
      classes,
      styles
    }
  }
}
</script>

<style lang="scss" scoped>
  .link-item {
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.8s;
    padding: 0.75rem 0.75rem 0.75rem 1rem;
    border-top: 0.125rem solid $neutral-04;
    border-left: 0.125rem solid $neutral-04;
    border-right: 0.125rem solid $neutral-04;
    cursor: pointer;

    &:last-child {
      border-bottom: 0.125rem solid $neutral-04;
    }

    &:hover {
      background-color: $neutral-01;
      color: $white !important;
    }

    @include textAlign();
  }
</style>
